<template>
    <inventories-get
        :tenancy="$route.query.tenancy"
        :page="page"
        :include="['files(paginate:1,1)']"
    >
        <div
            slot-scope="{
                data: inventories,
                meta,
                error,
                is_loading,
                has_loaded,
                get
            }"
            :class="!has_loaded || error ? '' : 'rounded bg-grey-bg shadow'"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="get"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else-if="meta.count > 0">
                <header class="flex items-center bg-white border-b rounded-t py-3 px-4 sm:px-6 md:py-3">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Inventories</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full text-grey fill-current"
                        />
                    </div>
                </header>

                <inventories-list :inventories="inventories" />

                <footer class="bg-grey-bg rounded-b pt-3 px-4 sm:px-6 text-sm text-grey-darker font-semibold">
                    <base-pagination
                        v-model="page"
                        v-if="meta.total > 0"
                        :per-page="meta.per_page"
                        :from="meta.from"
                        :to="meta.to"
                        :last-page="meta.last_page"
                        :count="meta.count"
                        :total="meta.total"
                        :is-disabled="is_loading"
                    />
                </footer>
            </template>

            <feature-right-image v-else>
                <template slot="heading">
                    No inventories found
                </template>

                <template slot="text">
                    We couldn't find any inventories that fit your search criteria.
                </template>

                <base-svg
                    slot="image"
                    name="illustration-empty"
                    class="w-full"
                />
            </feature-right-image>
        </div>
    </inventories-get>
</template>

<script>
    import InventoriesGet from '../../../../components/inventories-get'
    import InventoriesList from '../../../../components/inventories-list'
    import FeatureRightImage from '../../../../components/feature-right-image'
    import PaginationMixin from '../../../../mixins/pagination'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            InventoriesGet,
            InventoriesList,
            FeatureRightImage
        }
    }
</script>
